import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';

export type UserRole = 'ADMIN' | 'USER' | null;

export const useUserRole = (): {
  role: UserRole;
  isAdmin: boolean;
  isUser: boolean;
  loading: boolean;
} => {
  const { user, isLoading } = useAuth0();

  const role = useMemo(() => {
    if (isLoading || !user) {
      return null;
    }

    // Extract roles from Auth0 user object
    // Roles are in custom claim: https://ams-admin-v2/roles
    const roles = user['https://ams-admin-v2/roles'] as string[] | undefined;

    if (!roles || roles.length === 0) {
      return 'USER';  // Default to USER if no roles specified
    }

    // If user has ADMIN role, they're an admin
    if (roles.includes('ADMIN')) {
      return 'ADMIN';
    }

    // Otherwise they're a regular user
    return 'USER';
  }, [user, isLoading]);

  return {
    role,
    isAdmin: role === 'ADMIN',
    isUser: role === 'USER',
    loading: isLoading,
  };
};
